import dayjs from 'dayjs'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useSession } from 'components/Providers'
import { getCalendar } from 'store/lookup'

export function useMarkingPeriodDisabledDate() {
  const dispatch = useDispatch()
  const markingPeriods = useSelector(state => state.session.academicYear?.markingPeriods)
  const calendar = useSelector(state => state.lookup.calendar)
  const { campus } = useSession()

  useEffect(() => {
    if (!calendar && markingPeriods?.length) {
      const startDate = markingPeriods[0].startDate
      const endDate = markingPeriods[markingPeriods.length - 1].endDate
      dispatch(getCalendar({ startDate, endDate }))
    }
  }, [calendar, markingPeriods])

  return (date) => {
    if (!markingPeriods?.length) return false

    const outsideMarkingPeriods = !markingPeriods.some(mp =>
      !date.isBefore(dayjs(mp.startDate), 'day') && !date.isAfter(dayjs(mp.endDate), 'day')
    )
    if (outsideMarkingPeriods) return true

    if (calendar?.length) {
      const isNonSchoolDay = calendar.some(event =>
        event.isSchoolDay === false &&
        (!event.locationIds?.length || event.locationIds.includes(campus?.id)) &&
        !date.isBefore(dayjs(event.startDate), 'day') &&
        !date.isAfter(dayjs(event.endDate), 'day')
      )
      if (isNonSchoolDay) return true
    }

    return false
  }
}
